import '../common.css'
import './contact.css'

import * as $ from 'jquery';

$(() => {
    function hideModal() {
        $('.modal-background,.modal-container').removeAttr('style');
    }
    $('.modal-background,.modal-container').click(hideModal)
    $('form').on('submit', event => {
        event.preventDefault();
        const currentForm = $(event.currentTarget),
            params = {
                name: currentForm.find('#name').val(),
                phone: currentForm.find('#phone').val(),
                email: currentForm.find('#email').val(),
                remark: currentForm.find('#remark').val(),
            };
        console.log(params)
        // $.post('', params, response => { })
        $('.modal-background').show()
        setTimeout(() => { $('.modal-container').css('top', '0%') })
        setTimeout(hideModal, 1000)
    })
})
